<template>
  <div
    class="modal modal-sign-offs-create fade fixed-end"
    tabindex="-1"
    role="dialog"
  >
    <div
      class="modal-dialog modal-dialog-vertical dw-md-8 dw-lg-6 dw-xl-5"
      role="document"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h2 class="drawer-title">
            {{ title }}
          </h2>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <!-- /.drawer-heading -->

        <div class="modal-body">
          <div class="mb-3">
            <label class="control-label">Name</label>
            <input
              name="name"
              v-model="newAwsAccount.name"
              type="text"
              class="form-control"
              data-vv-validate-on="input|blur"
              data-vv-as="name"
              v-validate="'required'"
            />
            <help-block field="name" />
          </div>

          <div class="mb-3">
            <label class="control-label">AWS Account Id</label>
             <div class="input-group">
              <div class="flex-grow-1">
                <input
                  name="aws_account_id"
                  v-model="newAwsAccount.aws_account_id"
                  type="number"
                  class="form-control"
                  data-vv-validate-on="input|blur"
                  data-vv-as="name"
                  v-validate="'numeric'"
                />
              </div>
            </div>
            <help-block field="aws_account_id" />
          </div>

          <div class="mb-3">
            <label class="control-label">Terraform Workspace Name</label>
            <input
              name="name"
              v-model="newAwsAccount.terraform_workspace_name"
              type="text"
              class="form-control"
              data-vv-validate-on="input|blur"
              data-vv-as="name"
              v-validate="'required'"
            />
            <help-block field="name" />
          </div>

          

          <div class="mb-3">
            <label class="control-label">Charge</label>
            <c-checkbox
                v-model="newAwsAccount.charge"
                label=""
              />
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-default"
              data-bs-dismiss="modal"
            >
              Cancel
            </button>
            <c-button @click="handleSave" class="btn btn-rounded btn-primary"
              >Save</c-button
            >
          </div>
        </div>
        <!-- /.drawer-body -->
      </div>
      <!-- /.drawer-contents -->
    </div>
  </div>
  <!-- /.drawer -->
</template>

<style scoped>
.invalid-feedback {
  display: inline-block;
}
</style>

<style>
.form-control {
  box-shadow: none !important;
}

.form-control[readonly] {
  background-color: transparent !important;
}
</style>

<script>
import { notify } from "utils";
import { cloneDeep } from "lodash";
import Datepicker from "vuejs-datepicker";
import Multiselect from "vue-multiselect";
import { mapActions, mapState, mapGetters } from "vuex";
import { Selectize, LaddaButton } from "components/form/input";
import { helperMethods } from "vx/modules/clients";
import { CModal } from "@chameleon/chameleon-vue";

export default {
  $_veeValidate: {
    validator: "new", // give me my own validator scope.
  },
  props: ["title", "awsAccount", "mode"],
  extends: CModal,
  components: {
    Selectize,
    LaddaButton,
    Datepicker,
    Multiselect,
  },

  data() {
    return {
      newAwsAccount: {},
      client: null,
      awsAccountOptions: []
    };
  },

  mounted() {
    this.getClients();

    this.addEventListener('open', () => {
      this.newAwsAccount = cloneDeep(this.awsAccount)
    });
  },

  computed: {
  },
  methods: {
    ...helperMethods,
    ...mapActions("stack/awsAccount", ["addSingle", "updateSingle"]),

    handleSave() {
      if (this.newAwsAccount.id) {
        return this.handleUpdate();
      } else {
        return this.handleAdd();
      }
    },

    async handleAdd() {
      if (!(await this._validate())) {
        notify.error(
          "Form validation failed, please check your inputs and try again."
        );
        return Promise.reject();
      }

      console.log('add')

      try {
        return this.addSingle(this.newAwsAccount)
          .then((response) => {
            //Redirect to new opp
            this.close()
            this.$emit('created')
          })
          .catch((error) => {
            if (error.response.status === 422) {
              notify.error(
                "Form validation failed, please check your inputs and try again."
              );
            } else {
              console.error(error);
              notify.error("Failed to create Sign-Off, please try again.");
            }
          });
      } catch (error) {
        console.error(error);
      }
    },

    async handleUpdate() {
      if (!(await this._validate())) {
        notify.error(
          "Form validation failed, please check your inputs and try again."
        );
        return Promise.reject();
      }

      try {
        return this.updateSingle({
          id: this.newAwsAccount.id,
          payload: this.newAwsAccount,
        })
          .then((response) => {
            //In case client was changed, refresh the state from the api repsonse
            this.setClient(response.data.client);

            notify.success("Aws Account successfuly updated.");
            this.close();
            this.$emit("updated");
          })
          .catch((error) => {
            if (error.response.status === 422) {
              notify.error(
                "Form validation failed, please check your inputs and try again."
              );
            } else {
              console.error(error);
              notify.error("Failed to create budget, please try again.");
            }
          });
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>
